export default __webpack_public_path__ + "imgs/647d17c5e05226c3370ab18eb2d58c1e.jpg";